import React from 'react';
import BinTesterWithSiteConfig from '../component/bin-tester-with-site-config';

const BinTesterPage = (props) => {
    if (props.siteId == null) {
        return <div>Select a site</div>;
    }
    if (props.siteConfig.status !== 200) {
        return <div>Failed to load site configuration for {props.siteId}. Please contact SBL tech team.</div>;
    }
    return <BinTesterWithSiteConfig {...props}/>;
};

export default BinTesterPage;



// WEBPACK FOOTER //
// ./src/components/devicemanagement/ledcontroller/bintester/view/bin-tester-page.jsx